import { Grid2, Paper, IconButton } from "@mui/material";
import CustomTable from "./CustomTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useClientContext } from "../context/ClientContext";
import { clientGroups } from "../assets/clientData";
import { loanAccountL3 } from "../assets/loanAccountL3";
import { useState, useEffect } from "react";
import { formatCurrency } from "../utils/helper";

const LoanAccLevel3Table = ({ setLevel }) => {
  const [tableData, setTableData] = useState([]);
  const { clientName, clientGroup } = useClientContext();
  const columns = [
    {

      name: "Account Number",
      id: "id_number",
    },
    {
      name: "Product Name",
      id: "product_name",
    },
    {
      name: "Loan Type(Cash/Non-Cash)",
      id: "loan_type",
    },
    {
      name: "Credit Limit",
      id: "credit_limit",
      element: (row) => `${formatCurrency(row.credit_limit)}`,
    },
    {
      name: "Credit Outstanding",
      id: "outstanding",
      element: (row) => `${formatCurrency(row.outstanding)}`,
    },
    {
      name: "Credit Utilization %",
      id: "credit_utilization_percent",
    },
    {
      name: "Maturity Date",
      id: "maturity_date",
    },
    {
      name: "Overdue Payment",
      id: "overdue_payment",
      element: (row) => `${formatCurrency(row.overdue_payment)}`,
    },
    {
      name: "Account Status",
      id: "account_status",
    },

    {
      name: "Due Date",
      id: "due_date",
    },
  ];

  useEffect(() => {
    // Filter data based on selected client and group
    if (clientName && clientGroup) {
      const filteredData = loanAccountL3.filter(
        (data) =>
          data.company_name === clientName &&
          data.group_company === clientGroups.find((group) => group.group_name === clientGroup)?.label
      );


        //console.log('filteredData', filteredData);  
        setTableData(filteredData);
      
    }
  }, [clientName, clientGroup]);

  const handleTableView = () => {
    setLevel("L2.2");
  };

  return (
    <div className="my-4">
      <Grid2 display={"grid"} rowGap={2}>
        <div className="flex flex-start items-center h-[1rem] mx-1">
          <IconButton aria-label="<>" onClick={handleTableView}>
            <ArrowBackIcon sx={{ fontSize: 16 }} />
          </IconButton>

        </div>
        <div className="flex font-bold text-xs charts-data-container mx-4">
          Loan Accounts
        </div>
        <div className="mx-4" style={{ maxWidth: "50vw", overflowX: "auto" }}>
          <CustomTable columns={columns} data={tableData} hidePagination />
        </div>

      </Grid2>
    </div>
  );
};

export default LoanAccLevel3Table;
